
import { Options, Vue } from "vue-class-component";
// pages
import NavigationComponent from "@/components/navigationcomponent.vue";
// firebase
import {
  getAuth,
  onAuthStateChanged,
  signInWithEmailAndPassword,
} from "firebase/auth";
import {
  collection,
  getDocs,
} from "firebase/firestore";
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import { db } from "@/firebase";

@Options({
  components: {
    NavigationComponent,
  },
})
export default class Home extends Vue {

  public signedIn = false;
  public email: any = String();
  public password: any = String();
  public logo: any = String();
  public chatWindow = false;
  public userId: any = String();
  public emails: any = [];
  public messages: any = [];
  public messageData: any = [];
  public id: any = [];
  public all_emails: any = [];

  login() {
    const auth = getAuth();
    signInWithEmailAndPassword(auth, this.email, this.password)
      .then((userCredential) => {
        this.signedIn = true;
        this.$forceUpdate();
        this.$router.push("/");
      })
      .catch((error) => {
        console.log(error);
        alert("Wrong Password or Email. Please Try Again.");
        this.signedIn = false;
      });
  }

  created() {

    const storage = getStorage();

    getDownloadURL(ref(storage, "logos/logo.png")).then((url) => {
      this.logo = url;
    });

    const auth = getAuth();

    onAuthStateChanged(auth, (user) => {
      if (user) {
        this.signedIn = true;
      } else {
        this.signedIn = false;
      }

    });
  }
}
